<template>
    <div class="dummy-block-line preloadBgLight" :style="customStyling"></div>
</template>

<script>

export default {
    name: 'dummy-line',
    props: {
        // in %
        width: {
            type: Number,
            default: Math.floor((Math.random()*80) + 10),
        },
        // in PX
        height: {
            type: Number,
            default: Math.floor((Math.random()*10) + 1),
        },
        // in PX
        bottom: {
            type: Number,
            default: 15,
        },
    },
    computed:{
        customStyling(){
            return `height:${this.height}px;width:${this.width}%;margin-bottom:${this.bottom}px`
        }
    },
    
};
</script>


<style lang="scss">
@import "@/assets/vars.scss";
@import "@/assets/mixins.scss";
.dummy-block-line{
}
</style>